
import { SampleLinkGenerator } from "@/components/subscriptions/SampleLinkGenerator";
import { PublicSubscriptionLinkGenerator } from "@/components/subscriptions/PublicSubscriptionLinkGenerator";
import { Navigation } from "@/pages/home/components/Navigation";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const SampleLinks = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation isAdmin={false} />
      <div className="container mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold text-center mb-8">Sample Subscription Links</h1>
        
        <div className="max-w-2xl mx-auto">
          <Tabs defaultValue="product" className="w-full">
            <TabsList className="grid w-full grid-cols-2 mb-6">
              <TabsTrigger value="product">Product Subscription</TabsTrigger>
              <TabsTrigger value="public">Public Subscriptions</TabsTrigger>
            </TabsList>
            
            <TabsContent value="product" className="mt-0">
              <SampleLinkGenerator />
            </TabsContent>
            
            <TabsContent value="public" className="mt-0">
              <PublicSubscriptionLinkGenerator />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default SampleLinks;
